module.exports = __webpack_public_path__ + "./yutung-illustration_944e42eebf5c8a451d19364795ad6c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/yutung-illustration.png
// module id = 440
// module chunks = 0